// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandInputSelect_container__1ts-N","label":"BrandInputSelect_label__22v17","errorMsg":"BrandInputSelect_errorMsg__DNIkJ","error":"BrandInputSelect_error__2rPRM"};